import { createMachine, assign } from "xstate";
import { useMachine } from "@xstate/react";
import { useEffect } from "react";

export const DraftStates = {
  DEFAULT: "default",
  PREFLIGHT_RUNNING: "preflightRunning",
  PREFLIGHT_REVIEW: "preflightReview",
  WAITING_FOR_PROSE: "waitingForProse",
  POST_GENERATED_IDLE: "postGeneratedIdle",
  GENERATING_PROSE: "generatingProse",
  REWRITING_SCENES: "rewritingScenes",
};

export const draftStateMachine = createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QQE4EMBmAXAyltWYAsmgMYAWAlgHZgB0EYGaArgDZYDEs+KWACiiZtKUclgDaABgC6iUAAcA9rEpZKS6vJAAPRAEYATIYDsdACxSAzCasAOEwE4pLq4YA0IAJ6IAbL8M6AFYTQ399EwjDK30rAF84z1RMXHxCEgoaekZmdi4AWyUANzAAFSV+FSwAcTBadEIIAEkINjBpOSQQZVV1TW09BCNTC2tbB2dXD28-IzoTXyl9c0dHOzWg-V8EpPRsPAJiMipaOgUhDBExLAAlFmpqGihOc+FRcQBhJXyFNsaO7Q9NQaLRdQZRfR0KxSVZWcxBFaGBHTHwIOyQtyGZx2cwOaz6fSOHYgZL7NJHTKnV6Xd63MBFShgADu3F4NTqYAaT0EKnaskBKmB-TBiGiQToUkMUnRcIm9iCnlRdjhdDsISsayk8LVvhMxNJqUOGRO9GpV3EN3pjJZQgAjiw4HSmSg1GAcKQObAAV0gX1QaBBmKJVKZbinPLFYg3HZgkFJb59EE1oYjDj9XtDeljlkzhdzXSGczuB7aLAAKIQV0Qb2KQV+gaiqziyXS2JhxwRmYIKWQ0KOROSkwtkLbRIkjMHLOU0152mWwss2AluAVqsSfSdWu9EEN7tN4Ot2XhtWRhAJ8yqsL6LW+cy+dYp9MpScUk25t7XefWzikNDUD1sDW3R1juIp7s2IZtnKJ5doiUJBBq0pSv4CxEmOBovsaOZmnOVpFr+-5gIBG4CtuwoBo2EGHu2naov4F6+PYt7wk20KGOYT5kka2anEyaDAtQUAAGJKCgPKwGALwoLyloepQJTVvyPogeRuh+HYgSJgE5hhPeqEmKejgJnQupqjCNhMfYnGZq+OZ8QJwmieJkkEQBzm1PUBAgkBvqgRRZ4aXQWnsbpDi+I4BldsqF5qrYmrakEurWZhPH0PZ6iCSJYnSRJP5-m5OVgB5nJeZo66bsBZH+mpAWaYlIX+GFEWniYaoSuYKzLOYThxgsyXklhVJVMVDSQC0bSsmgfCCB+4g+Sp1XgqEGIwh28KIsip5BkmyxBBpyr2FIQT9dx050DAnkZVAzkvKwEnzVVu7DGYlgWRMLjWCiiCOEE4phFYjHJs4MTxOhE4Dal50clygk3ecvJfD8fyQA9QqLQYxgvWM9hOB9binteR0SgsSwTKEjUnVOb5CM6Dnup6nA0y6hD06WiO-GA-xKVuaO7vedXaaF+mnpiQWsY4UoIYdoO7M+ENnUzdPLrAjPMszbrK+zyPViRymPWB-NBfVOmNcLXY2JCjjdSYkSSlsiZpsS1BKIw8BdBh8smqRvNgQAtL4p7+5TtmnDkrAcN79ZgdeJgXp1ljXj2LiRXRhJQgD9VbCOhh2MHg0zrNtz3I8gmR35NWEvuBKEjbHXwgsCpdh2JlSLqCI6UZUgmL9eeQzhn54UyZeqYMOmnisUgSomVhuIm-ZhLYvdnelTxZc5w-owgcaOCZURInPEUdaeyrNvodgaYSazQr4x1g3Lp1vj07KXWNrRgBvT0IZb0pW7iBIrL9Lacw4Q9UWLiNYDhc53y4lTHMF0SpXXXnrH2-lrwIQlLqG2Gp6LKkcIZYyuCNgBAQkOGW4576wNOIrK6rM4AfzAtvXeoR95JkPuYEWOd5gElsK1FYkRf4JASEAA */
  id: "draftStateMachine",
  initial: DraftStates.DEFAULT,
  context: {
    hasBeenToPostGeneratedIdle: false,
  },
  on: {
    reset: {
      target: `.${DraftStates.DEFAULT}`,
      actions: assign({ hasBeenToPostGeneratedIdle: false }),
    },
  },
  states: {
    [DraftStates.DEFAULT]: {
      on: {
        startPreflight: { target: DraftStates.PREFLIGHT_RUNNING },
        moveToPostGeneratedIdle: { target: DraftStates.POST_GENERATED_IDLE },
      },
    },
    [DraftStates.PREFLIGHT_RUNNING]: {
      on: {
        preflightCompleted: { target: DraftStates.PREFLIGHT_REVIEW },
      },
    },
    [DraftStates.PREFLIGHT_REVIEW]: {
      on: {
        startPreflight: { target: DraftStates.PREFLIGHT_RUNNING },
        startGeneratingProse: { target: DraftStates.WAITING_FOR_PROSE },
        requestRewriteScenes: { target: DraftStates.REWRITING_SCENES },
        scenesEdited: { target: DraftStates.DEFAULT },
        cancel: { target: DraftStates.DEFAULT },
      },
    },
    [DraftStates.WAITING_FOR_PROSE]: {
      on: {
        proseReceived: { target: DraftStates.GENERATING_PROSE },
        cancelProseGeneration: [
          {
            target: DraftStates.POST_GENERATED_IDLE,
            guard: ({ context }) => context.hasBeenToPostGeneratedIdle,
          },
          {
            target: DraftStates.DEFAULT,
          },
        ],
      },
    },
    [DraftStates.POST_GENERATED_IDLE]: {
      entry: assign({
        hasBeenToPostGeneratedIdle: true,
      }),
      on: {
        startPreflight: { target: DraftStates.PREFLIGHT_RUNNING },
        resetToDefault: { target: DraftStates.DEFAULT },
      },
    },
    [DraftStates.GENERATING_PROSE]: {
      on: {
        // Metadata and headings can enter this state before actual prose.
        cancelProseGeneration: [
          {
            target: DraftStates.POST_GENERATED_IDLE,
            guard: ({ context }) => context.hasBeenToPostGeneratedIdle,
          },
          { target: DraftStates.DEFAULT },
        ],
        pause: { target: DraftStates.POST_GENERATED_IDLE },
        proseCompleted: { target: DraftStates.POST_GENERATED_IDLE },
      },
    },
    [DraftStates.REWRITING_SCENES]: {
      on: {
        rewriteScenesCompleted: [
          {
            target: DraftStates.POST_GENERATED_IDLE,
            guard: ({ context }) => context.hasBeenToPostGeneratedIdle,
          },
          {
            target: DraftStates.DEFAULT,
          },
        ],
      },
    },
  },
});

export const useDraftStateMachine = (initialState = DraftStates.DEFAULT) => {
  const [state, send] = useMachine(draftStateMachine);

  useEffect(() => {
    // due to lag in the data loading, the initial state is not always set the first time
    // we want to make sure that postGeneratedIdle is available when appropriate,
    // so we handle it here.
    if (initialState === DraftStates.POST_GENERATED_IDLE && state.value === DraftStates.DEFAULT) {
      send({ type: "moveToPostGeneratedIdle" });
    }
    if (initialState === DraftStates.DEFAULT && state.value === DraftStates.POST_GENERATED_IDLE) {
      send({ type: "resetToDefault" });
    }
  }, [initialState, state.value, send]);

  return {
    value: state.value,
    events: {
      startPreflight: () => send({ type: "startPreflight" }),
      preflightCompleted: () => send({ type: "preflightCompleted" }),
      startGeneratingProse: () => send({ type: "startGeneratingProse" }),
      proseReceived: () => send({ type: "proseReceived" }),
      cancelProseGeneration: () => send({ type: "cancelProseGeneration" }),
      proseCompleted: () => send({ type: "proseCompleted" }),
      pause: () => send({ type: "pause" }),
      scenesEdited: () => send({ type: "scenesEdited" }),
      requestRewriteScenes: () => send({ type: "requestRewriteScenes" }),
      rewriteScenesCompleted: () => send({ type: "rewriteScenesCompleted" }),
      cancel: () => send({ type: "cancel" }),
      reset: () => send({ type: "reset" }),
    },
  };
};
